import styled from "styled-components"

export const TherapyPageWrapper = styled.div``
